import type { FC, ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import type { PermissionEnum } from '@shared/api';
import { Routes } from '@shared/constants/routes';
import { hasRequiredPermission, getDefaultOrganizationRoute } from '@shared/lib/permissions';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';

interface PermissionRouteProps {
  children: ReactNode;
  requiredPermission?: PermissionEnum;
}

export const PermissionRoute: FC<PermissionRouteProps> = ({ children, requiredPermission }) => {
  const selfPermission = useAppSelector(authSelectors.selectSelfPermission);
  const currentOrganizationId = useAppSelector(authSelectors.selectCurrentOrganizationId);
  const { organizationId } = useParams<{ organizationId?: string }>();

  if (hasRequiredPermission(selfPermission, requiredPermission)) {
    return <>{children}</>;
  }

  const fallbackRoute = getDefaultOrganizationRoute(
    selfPermission,
    organizationId ?? currentOrganizationId,
  );

  return <Navigate to={fallbackRoute || Routes.profile.organization.root} replace />;
};
